/** Created by azhou on 2019/3/18.*/
<template>
    <div class="d-center flex-column">
      <left-text-border required class="mb-3 w-50" leftText="输入旧密码" type="password" v-model="oldPassword"/>
      <left-text-border required class="mb-3 w-50" leftText="输入新密码" type="password" v-model="newPassword"/>
      <left-text-border required class="mb-3 w-50" leftText="确认新密码" type="password" v-model="confirmPassword"/>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'PwdSet',
    data() {
      return {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    methods:{
      ...mapActions(['modifyPwd']),
      submitForm() {
        if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
          this._alert('密码不得为空！',null,'error');
          return;
        }
        this._confirm('确认修改密码么',() => {
          this.modifyPwd({
            data:{
              oldPwd:this.oldPassword,
              password:this.newPassword,
              repassword:this.confirmPassword
            },
            successFun(){
              location.reload()
            }
          })
        })
      }
    }
  }
</script>
